import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { FlatList } from 'react-native';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
export default function V2ThumbnailRow({ accessibility, reviews, toiletReviews, }) {
    var _a, _b;
    const navigation = useNavigation();
    // V2: plural 배열 대응 (하위 호환 fallback)
    const placeAccessibilities = (_a = accessibility === null || accessibility === void 0 ? void 0 : accessibility.placeAccessibilities) !== null && _a !== void 0 ? _a : ((accessibility === null || accessibility === void 0 ? void 0 : accessibility.placeAccessibility)
        ? [accessibility.placeAccessibility]
        : []);
    const buildingAccessibilities = (_b = accessibility === null || accessibility === void 0 ? void 0 : accessibility.buildingAccessibilities) !== null && _b !== void 0 ? _b : ((accessibility === null || accessibility === void 0 ? void 0 : accessibility.buildingAccessibility)
        ? [accessibility.buildingAccessibility]
        : []);
    const placeImages = placeAccessibilities.flatMap(pa => {
        var _a;
        return ((_a = pa.images) !== null && _a !== void 0 ? _a : []).map(image => ({
            type: '장소 입구',
            url: image.imageUrl,
            thumbnailUrl: image.thumbnailUrl,
        }));
    });
    const buildingImages = buildingAccessibilities.flatMap(ba => {
        var _a;
        return ((_a = ba.entranceImages) !== null && _a !== void 0 ? _a : []).map(image => ({
            type: '건물 입구',
            url: image.imageUrl,
            thumbnailUrl: image.thumbnailUrl,
        }));
    });
    const elevatorImages = buildingAccessibilities.flatMap(ba => {
        var _a;
        return ((_a = ba.elevatorImages) !== null && _a !== void 0 ? _a : []).map(image => ({
            type: '엘리베이터',
            url: image.imageUrl,
            thumbnailUrl: image.thumbnailUrl,
        }));
    });
    const placeIndoorImages = (reviews !== null && reviews !== void 0 ? reviews : [])
        .filter(review => (review === null || review === void 0 ? void 0 : review.images) && review.images.length > 0)
        .flatMap(review => review.images)
        .filter((image) => typeof (image === null || image === void 0 ? void 0 : image.imageUrl) === 'string')
        .map(image => ({
        type: '장소 내부',
        url: image.imageUrl,
        thumbnailUrl: image.thumbnailUrl,
    }));
    const toiletImagesData = (toiletReviews !== null && toiletReviews !== void 0 ? toiletReviews : [])
        .filter(review => (review === null || review === void 0 ? void 0 : review.images) && review.images.length > 0)
        .flatMap(review => review.images)
        .filter((image) => typeof (image === null || image === void 0 ? void 0 : image.imageUrl) === 'string')
        .map(image => ({
        type: '장애인 화장실',
        url: image.imageUrl,
        thumbnailUrl: image.thumbnailUrl,
    }));
    const thumbnailImages = [
        ...placeImages,
        ...placeIndoorImages,
        ...buildingImages,
        ...elevatorImages,
        ...toiletImagesData,
    ];
    if (thumbnailImages.length === 0) {
        return null;
    }
    const onPressImage = (index) => {
        navigation.navigate('ImageZoomViewer', {
            imageUrls: thumbnailImages.map(image => image.url),
            index,
            types: thumbnailImages.map(t => t.type),
        });
    };
    return (_jsx(FlatList, { horizontal: true, data: thumbnailImages, keyExtractor: (_, index) => String(index), showsHorizontalScrollIndicator: false, contentContainerStyle: { paddingLeft: 20, paddingRight: 20, gap: 8 }, renderItem: ({ item, index }) => {
            var _a;
            return (_jsx(SccPressable, { elementName: "place_detail_v2_thumbnail", logParams: { index }, onPress: () => onPressImage(index), children: _jsxs(ThumbnailCard, { children: [_jsx(ThumbnailImage, { source: { uri: (_a = item.thumbnailUrl) !== null && _a !== void 0 ? _a : item.url } }), _jsx(TypeLabel, { children: _jsx(TypeLabelText, { children: item.type }) })] }) }));
        } }));
}
const ThumbnailCard = styled.View `
  width: 200px;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;
const ThumbnailImage = styled.Image `
  width: 200px;
  height: 200px;
`;
const TypeLabel = styled.View `
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 100px;
  padding-horizontal: 8px;
  padding-vertical: 2px;
`;
const TypeLabelText = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${color.white};
`;
